import React from 'react';
import PropTypes from 'prop-types';
import { Col, Form, Button } from 'react-bootstrap';

import { getFirstName, getLastName, getEmailAddress } from '../../../api/Users/user-operations';

const PasswordUserProfile = ({ user }) => (
  <>
    <Form.Row>
      <Form.Group as={Col} xs={6}>
        <Form.Label>First Name</Form.Label>
        <Form.Control type="text" name="firstName" defaultValue={getFirstName(user)} />
      </Form.Group>
      <Form.Group as={Col} xs={6}>
        <Form.Label>Last Name</Form.Label>
        <Form.Control type="text" name="lastName" defaultValue={getLastName(user)} />
      </Form.Group>
    </Form.Row>
    <Form.Group>
      <Form.Label>Email Address</Form.Label>
      <Form.Control type="email" name="emailAddress" defaultValue={getEmailAddress(user)} />
    </Form.Group>
    <hr />
    <Form.Group>
      <Form.Label>Current Password</Form.Label>
      <Form.Control type="password" name="currentPassword" />
    </Form.Group>
    <Form.Group>
      <Form.Label>New Password</Form.Label>
      <Form.Control type="password" name="newPassword" />
      <Form.Text className="text-muted">Use at least six characters.</Form.Text>
    </Form.Group>
    <Form.Group>
      <Form.Label>Repeat New Password</Form.Label>
      <Form.Control type="password" name="repeatNewPassword" />
    </Form.Group>
    <Button type="submit" variant="success">
      Save Profile
    </Button>
  </>
);

PasswordUserProfile.propTypes = {
  user: PropTypes.object.isRequired
};

export default PasswordUserProfile;
